import { injectable } from 'inversify';

import container from '@core/di';
import BaseStore from '@core/stores/base';
import AssessmentsHistoryService from 'src/shared/services/assessmentshistory';
import { AssessmentListItem } from '@shared/models/assesmentlistitem';

@injectable()
export default class AssessmentsHistoryStore extends BaseStore<
  AssessmentListItem,
  AssessmentsHistoryService
> {
  static diToken = Symbol('assessmentshistory-store');

  constructor() {
    super({ service: container.get<AssessmentsHistoryService>(AssessmentsHistoryService.diToken) });

    this.loading = {
      list: false,
      item: false,
    };
  }

  getAssessmentsHistoryList = async (clientPrimaryAccountId: number, _: number) => {
    return await this.service.getAssessmentsHistoryList(clientPrimaryAccountId);
  };
}
